import { useMemo } from "react";
import { useBooleanFlag } from "@apac/feature-flags";
import type { CreditCard } from "@b2bportal/card-api";
import {
  CardPaymentSelectors,
  useCheckoutStateSelector as useSelector,
} from "@hopper-b2b/checkout";
import { getCardByBin, FeatureFlagNames } from "@hsbc/utilities";

interface UseSelectedPaymentInformationReturn {
  selectedPayment: CreditCard;
  cardName?: string;
}

export const useSelectedPaymentInformation =
  (): UseSelectedPaymentInformationReturn => {
    const disableBinCheck = useBooleanFlag(FeatureFlagNames.DISABLE_BIN_CHECK);
    const creditCards = useSelector(CardPaymentSelectors.getPaymentMethods);
    const selectedPaymentMethodId = useSelector(
      CardPaymentSelectors.getSelectedPaymentMethodId
    );

    const selectedPayment = useMemo(
      () =>
        creditCards.find((payment) => payment.id === selectedPaymentMethodId),
      [creditCards, selectedPaymentMethodId]
    );

    // user can pay full in credit or points without card
    const cardName = selectedPayment
      ? getCardByBin(selectedPayment?.bin, disableBinCheck).name
      : undefined;

    return { selectedPayment, cardName };
  };
